import {configureStore} from "@reduxjs/toolkit";
import tripsFilterReducer from "./slicers/tripsFilterSlicer";
import TelematicsReducer from "./slicers/videoTelematicsFilterSlicer";

export default configureStore({
    reducer: {
        tripsFilter: tripsFilterReducer,
        telematicsFilter: TelematicsReducer
    }
})
